import { useWatch } from 'react-hook-form';
import type { FormMode } from '@/types/form';
import { BottomBar } from './BottomBar';

interface BottomBarWrapperProps {
  formMode: FormMode;
  totalAmount: number;
  totalAmountNT: number;
}

export const BottomBarWrapper = ({ formMode, totalAmount, totalAmountNT }: BottomBarWrapperProps) => {
  const ty_gia = useWatch({ name: 'ty_gia' }) || '1';
  const exchangeRate = parseFloat(ty_gia);

  return (
    <BottomBar totalAmount={totalAmount} totalAmountNT={totalAmountNT} formMode={formMode} ty_gia={exchangeRate} />
  );
};
